@import 'styles/variables';

.loadMore {
  margin: map-get($spacers, 4) auto;
  text-align: center;
}
